import { render } from "./HistoryColis.vue?vue&type=template&id=2be56b09&ts=true"
import script from "./HistoryColis.vue?vue&type=script&lang=ts"
export * from "./HistoryColis.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__